
import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AtelierHero from './components/AtelierHero';
import AtelierFeatures from './components/AtelierFeatures';
import AtelierUseCases from './components/AtelierUseCases';
import AtelierSpecs from './components/AtelierSpecs';
import AtelierLineCTA from './components/AtelierLineCTA';
import AtelierEmailForm from './components/AtelierEmailForm';
import AtelierMeVEREcosystem from './components/AtelierMeVEREcosystem';
import StickyLineBar from './components/StickyLineBar';

export default function AtelierFolioPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Ensure page starts at the top when component mounts
    window.scrollTo(0, 0);

    const handleScroll = () => {
      // Guard against undefined window.scrollY in non‑browser environments
      if (typeof window !== 'undefined' && typeof window.scrollY === 'number') {
        setScrolled(window.scrollY > 50);
      }
    };

    // Add scroll listener (passive improves performance)
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="relative bg-[#0A0A0A] min-h-screen">
      <Navbar scrolled={scrolled} />
      {/* Spacer to offset the fixed navbar */}
      <div className="pt-16 sm:pt-20"></div>

      <main>
        <AtelierHero />
        <AtelierFeatures />
        <AtelierUseCases />
        <AtelierSpecs />
        <AtelierLineCTA />
        <AtelierMeVEREcosystem />
        <AtelierEmailForm />
      </main>

      <Footer />
      <StickyLineBar />
    </div>
  );
}
